import React, { useState } from 'react';
import { Form, Input, Alert, Typography, Card, Button } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthAPI } from '../api/authApi';
import styles from './login.module.scss';

const { Title } = Typography;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const NewPassword = () => {
  const [error, setError] = useState('');
  const [form] = Form.useForm();
  const query = useQuery();
  const navigate = useNavigate();
  const passwordToken = query.get('passwordToken');

  const handleFinish = async (values) => {
    if (!passwordToken) {
      setError('Nedostaje token za resetovanje sifre.');
      return;
    }

    const password = values.password;
    const { success, message } = await AuthAPI.resetPassword({
      password,
      passwordToken,
    });

    if (success) {
      setTimeout(() => {
        navigate('/promenjena-sifra');
      }, 500);
    } else {
      setError(message);
    }
  };

  return (
    <div className={styles.login}>
      <div className={styles.login__left}>
        <div className={styles.login__logo}>
          <Link to="/">
            <img src="/logo.svg" alt="Logo" height={30} width={100} />
          </Link>
        </div>
        <div className={styles.login__formCard}>
          <Card className={styles.login__card}>
            <img
              src="/assets/icons/new-pass.svg"
              alt="New password"
              width={48}
              height={48}
              style={{ marginBottom: 24 }}
            />
            <Title className={styles.login__title} level={1}>
              Nova sifra
            </Title>

            <Form layout="vertical" onFinish={handleFinish} form={form}>
              <Form.Item
                label="Nova sifra"
                name="password"
                rules={[{ required: true, message: 'Unesite sifru!' }]}
              >
                <Input.Password />
              </Form.Item>

              {error && (
                <Alert
                  title={error}
                  type="error"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}

              <Form.Item className={styles.login__submit}>
                <Button type="primary" htmlType="submit">
                  Sacuvaj sifru
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
      <div className={styles.login__right}></div>
    </div>
  );
};

export default NewPassword;
